import cx from 'clsx';
import type { ImageProps } from 'next/legacy/image';

import { ShoebillImage } from '~/components/Image';
import type { OAISchema } from '~/types/openapi';

import ProductDisabledImageOverlay from './ProductDisabledImageOverlay';

export type StatusType = OAISchema['MarketProductDetailsResponseV2']['status'];

type Props = {
  src: string;
  alt?: string;
  type?: 'list' | 'grid';
  isOutOfStock?: boolean;
  rightBottom?: React.ReactNode;
  status?: StatusType;
  inverse?: boolean;
  className?: string;
  imageWrapperClassName?: string;
  leftTop?: React.ReactNode;
} & ImageProps;

function ProductImage({
  src,
  alt,
  isOutOfStock,
  rightBottom,
  type = 'grid',
  status,
  inverse,
  className,
  imageWrapperClassName,
  leftTop,
  ...props
}: Props) {
  return (
    <div
      className={cx([
        'relative overflow-hidden rounded-16 border border-02 bg-screen-01 mb-8',
        inverse && 'after:bg-gray-000 [&>div]:z-10',
        className,
      ])}
    >
      <div className={cx('aspect-w-1 aspect-h-1', imageWrapperClassName)}>
        <div>
          <ShoebillImage {...props} src={src} alt={alt} objectFit="contain" />
        </div>
      </div>
      <ProductDisabledImageOverlay
        type={type}
        status={status}
        isOutOfStock={isOutOfStock}
      />
      {leftTop && <div className="absolute left-0 top-0">{leftTop}</div>}
      {rightBottom && (
        <div className="absolute bottom-0 right-0">{rightBottom}</div>
      )}
    </div>
  );
}

export default ProductImage;
